import { permissionColumns as columns } from "../../Helper";

const GetPermissionTableColumns = () => {
  return columns;
};

export default GetPermissionTableColumns;
